import JobPreview from 'src/pages/JobPreview';
import { Navigate, Route, Routes } from 'react-router-dom';
import EditPositionRouter from 'src/pages/editPosition';
import CreatePositionRouter from 'src/pages/CreatePosition';
import RecruiterCandidatesPage from 'src/pages/RecruiterCandidatesPage';
import RecruiterPositionsPage from 'src/pages/RecruiterPositionsPage';
import Job from 'src/pages/Job';
import LinkedInEmptyPage from 'src/pages/LinkedInEmptyPage';
import LinkedinOpenAuth from 'src/pages/LinkedinOpenAuth';
import Explainers from 'src/pages/Explainers';
import { useUserContext } from 'src/context/UserProvider';
import { useGetUserProfile } from 'src/hooks/profile.hooks';
import { RecruiterSupport } from 'src/pages/recruiter-support/RecruiterSupport';
import AMEditCompany from 'src/components/accountManager/AMEditCompany';
import RecruiterFlywheelPage from 'src/components/recruiterPositions/RecruiterFlywheelPage';
import { useQueryClient } from 'react-query';
import { GetPositionsForRecruiterAPIResponse, UserExperienceLevelType } from 'types';
import { QueryState } from 'react-query/types/core/query';
import SelectHiringFlowPage from 'src/pages/newRecruiterFlow/SelectHiringFlowPage';
import CampusCandidatesListingPage from 'src/pages/newRecruiterFlow/CampusCandidatesListingPage';
import UpcomingDriveListingPage from 'src/pages/newRecruiterFlow/UpcomingDriveListingPage';
import RecruiterDashboard from 'src/pages/RecruiterDashboard';
import ShareHiringAssessment from 'src/components/recruiterPositions/recruiterTypes/ShareHiringAssessment';
import CreateHiringAssessment from 'src/components/recruiterPositions/recruiterTypes/CreateHiringAssessment';
import DriveFormForRecruiter from 'src/pages/newRecruiterFlow/DriveFormForRecruiter';
import HiringAssessmentListPage from 'src/pages/newRecruiterFlow/HiringAssessmentListPage';
import HiringAssessmentCandidatePage from 'src/pages/newRecruiterFlow/HiringAssessmentCandidatePage';
import HiringAssessmentCandidateListing from 'src/components/recruiterPositions/recruiterTypes/HiringAssessment/HiringAssessmentCandidateListing';
import FresherCandidateListing from 'src/components/newRecruiterFlow/freshers/FresherCandidateListing';
import PositionCandidateListing from 'src/components/newRecruiterFlow/freshersPosition/PositionCandidateListing';
import NewRecruiterPositionsPage from 'src/pages/newRecruiterFlow/NewRecruiterPositionsPage';
import DrivePositionsPage from 'src/pages/newRecruiterFlow/DrivePositionsPage';
import DriveCandidatesListingPage from 'src/pages/newRecruiterFlow/DriveCandidatesListingPage';
import Profile from 'src/pages/profile/Profile';
import DrivePrototype from 'src/pages/newRecruiterFlow/DrivePrototype';
import HiringAssessmentGraph from 'src/components/recruiterPositions/recruiterTypes/HiringAssessment/HiringAssessmentGraph';
import CreateAssessmentWithParameterAndWeightagePage from 'src/components/recruiterPositions/recruiterTypes/CreateAssessmentWithParameterAndWeightagePage';
import EditDrivePositionRouter from 'src/pages/editDrivePosition';

const RecruiterRoutes = () => {
	const { user, hasPosition } = useUserContext();
	const queryClient = useQueryClient();
	const userProfile = useGetUserProfile(user?.handler ?? '');
	const getMyPositionsData: QueryState<GetPositionsForRecruiterAPIResponse, undefined> | undefined =
		queryClient.getQueryState(['getMyRegisteredPositions', '']);

	if (userProfile.isLoading) {
		return null;
	}

	// if (
	// 	userProfile.data?.userDetail?.flags?.isSystemCreated &&
	// 	getMyPositionsData?.data?.positions &&
	// 	getMyPositionsData?.data?.positions?.length === 0 &&
	// 	!hasPosition
	// ) {
	// 	return (
	// 		<Routes>
	// 			<Route path="/create-position" element={<CreatePositionRouter />} />
	// 			<Route path="/candidate-profiles" element={<RecruiterFlywheelPage />} />
	// 			<Route path="/edit-company/:companyId" element={<AMEditCompany />} />
	// 			<Route path="/support" element={<RecruiterSupport />} />
	// 			<Route path="/job-preview/:jobId" element={<JobPreview />} />
	// 			<Route path="*" element={<Navigate to="/candidate-profiles" />} />
	// 		</Routes>
	// 	);
	// }
	// add a redirect to every route if onboarding is not completed
	// else if (userProfile.data?.userDetail?.flags.showOnboardingVideo) {
	// 	return (
	// 		<Routes>
	// 			<Route path="/onboarding" element={<Onboarding />} />
	// 			<Route path="/create-position" element={<CreatePositionRouter />} />
	// 			<Route path="/edit-company/:companyId" element={<AMEditCompany />} />
	// 			<Route path="*" element={<Navigate to="/onboarding" />} />
	// 		</Routes>
	// 	);
	// }

	return (
		<Routes>
			<Route path="/recruiter-dashboard" element={<RecruiterDashboard />} />
			<Route path="/recruiter-dashboard/hiring-assessment-list" element={<HiringAssessmentListPage />} />
			<Route path="/recruiter-dashboard/hiring-assessment-graph/:id" element={<HiringAssessmentGraph />} />

			<Route path="/recruiter-dashboard/hiring-assessment-list/:id" element={<HiringAssessmentCandidateListing />} />
			<Route
				path="/recruiter-dashboard/hiring-assessment/:hiringAssessmentId/candidates"
				element={<HiringAssessmentCandidatePage />}
			/>
			<Route path="/edit-company/:companyId" element={<AMEditCompany />} />
			<Route path="/linkedin-auth" element={<LinkedinOpenAuth />} />
			{/* <Route path="/select-hiring-type" element={<SelectHiringFlowPage />} /> */}
			<Route path="/select-hiring-type" element={<DrivePrototype />} />
			{/* <Route path="/drive-prototype" element={<DrivePrototype />} /> */}
			<Route path="/recruiter-dashboard/positions" element={<NewRecruiterPositionsPage />} />
			<Route path="/campus-candidates" element={<CampusCandidatesListingPage />} />
			<Route
				path="/fresher-candidates"
				element={<FresherCandidateListing experienceLevelBuckets={[UserExperienceLevelType.FRESHER]} />}
			/>
			<Route
				path="/experience-candidates"
				element={
					<FresherCandidateListing
						experienceLevelBuckets={[UserExperienceLevelType.OneToTwoYears, UserExperienceLevelType.TwoPlusYears]}
					/>
				}
			/>
			<Route path="/view-candidates/position/:positionId" element={<PositionCandidateListing />} />
			<Route path="/upcoming-drives" element={<UpcomingDriveListingPage />} />
			<Route path="/drive-positions" element={<DrivePositionsPage />} />
			<Route path="/drive-positions/candidates/:id" element={<DriveCandidatesListingPage />} />
			<Route path="/drive-form" element={<DriveFormForRecruiter />} />
			<Route path="/linkedin" element={<LinkedInEmptyPage />} />
			<Route path="/positions" element={<RecruiterPositionsPage />} />
			<Route path="/support" element={<RecruiterSupport />} />
			<Route path="/create-position" element={<CreatePositionRouter />} />
			<Route path="/job-preview/:jobId" element={<JobPreview />} />
			<Route path="/explainers/:jobId" element={<Explainers />} />
			<Route path="/edit-position/:jobId" element={<EditPositionRouter />} />
			<Route path="/positions/:positionId/candidates" element={<RecruiterCandidatesPage />} />
			<Route path="/benchmarking/create-hiring-assessment" element={<CreateHiringAssessment />} />
			<Route
				path="/benchmarking/create-hiring-assessment/parameter-weightage"
				element={<CreateAssessmentWithParameterAndWeightagePage />}
			/>

			<Route path="/benchmarking/share-hiring-assessment" element={<ShareHiringAssessment />} />
			<Route path="/job/:jobId" element={<Job />} />
			<Route path="/profile/:userHandler" element={<Profile />} />
			<Route path="/edit-drive-position/:positionId" element={<EditDrivePositionRouter />} />
			<Route path="*" element={<Navigate to="/select-hiring-type" />} />
		</Routes>
	);
};

export default RecruiterRoutes;
